import { defer } from "react-router-dom";
import { getFormatTimeByPattern } from "@didi/elvish-lib-javascript";
import { resolveLoaderResult } from "@/routes/loaderResult";
import { BillType } from "./common/config";
import { getList, getOptions } from "./common/services";
import { selectOption } from "./common/types";

const pageSize = 20;

function getSelectedOptions() {
  try {
    return JSON.parse(sessionStorage.getItem("selectedOptions") || "{}");
  } catch (error) {
    console.log("err :>> transaction.loader.selectedOptions:", error);
    return {};
  }
}

export function transactionLoader() {
  let selectTypeOption: selectOption = { label: "", type: BillType.all };
  const now = new Date();
  let selectMonth = now.getMonth() + 1;
  let selectYear = now.getFullYear();

  try {
    selectMonth = Number(getFormatTimeByPattern(Date.now() / 1000, "MM"));
    selectYear = Number(getFormatTimeByPattern(Date.now() / 1000, "yyyy"));
    const selectedOptions = getSelectedOptions();
    selectTypeOption = selectedOptions.selectTypeOption
      ? { ...selectedOptions.selectTypeOption }
      : selectTypeOption;
    selectMonth = selectedOptions.selectMonth || selectMonth;
    selectYear = selectedOptions.selectYear || selectYear;
  } catch (error) {
    console.log("err :>> transaction.loader.init:", error);
  }

  return defer({
    coreData: resolveLoaderResult(
      getList({
        pageNum: 1,
        pageSize,
        selectMonth,
        selectYear,
        type: selectTypeOption.type,
      }).then((list) => list || {}),
    ),
    optionsData: resolveLoaderResult(getOptions().then((options) => options || {})),
  });
}
